// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9666) return "static/chunks/9666-8f685e075a2934fb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1055":"e93cde247d034b82","3624":"e77d3d47a2cd6246"}[chunkId] + ".js";
};